import script from "./CancelBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./CancelBtn.vue?vue&type=script&lang=ts&setup=true"

import "./CancelBtn.vue?vue&type=style&index=0&id=424747a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424747a2"]])

export default __exports__